"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const assets_1 = require("@pixi/assets");
const gsap_1 = require("gsap");
class AceOfShadows {
    constructor(app) {
        this.assets = {};
        this.app = app;
        this.stack = [];
        this.start();
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.loadAssets();
                this.createStacks();
                this.moveCard();
            }
            catch (error) {
                console.error('Failed to load assets:', error);
            }
        });
    }
    loadAssets() {
        return __awaiter(this, void 0, void 0, function* () {
            const manifest = {
                bundles: [{
                        name: 'bundle',
                        assets: [
                            {
                                name: 'card',
                                src: AceOfShadows.CARD_ASSET_PATH
                            }
                        ]
                    }]
            };
            yield assets_1.Assets.init({ manifest });
            this.assets = yield assets_1.Assets.loadBundle('bundle');
        });
    }
    getStackCenter() {
        return {
            x: this.app.renderer.width / 2,
            y: this.app.renderer.height / 2
        };
    }
    createCard(x, y, index) {
        const card = pixi_js_1.Sprite.from(this.assets.card);
        card.anchor.set(0.5);
        card.position.set(x, y + index * AceOfShadows.CARDS_SHIFTER);
        return card;
    }
    createStacks() {
        const { x: centerX, y: centerY } = this.getStackCenter();
        const stack = new pixi_js_1.Container();
        for (let i = 0; i < AceOfShadows.TOTAL_CARDS; i++) {
            stack.addChild(this.createCard(centerX * 0.5, centerY * 0.5, i));
        }
        this.app.stage.addChild(stack);
        this.stack.push(stack);
    }
    moveCard() {
        let counter = 0;
        const { x: centerX, y: centerY } = this.getStackCenter();
        this.intervalId = window.setInterval(() => {
            if (!this.stack[0].children.length) {
                clearInterval(this.intervalId);
                return;
            }
            const topCard = this.stack[0].children.pop();
            gsap_1.gsap.to(topCard.position, {
                x: centerX + centerX * 0.5,
                y: centerY * 0.5 + counter * AceOfShadows.CARDS_SHIFTER,
                duration: 1,
                ease: "power3.inOut"
            });
            this.app.stage.addChild(topCard);
            counter++;
        }, 2000);
    }
    destroy() {
        // Clear all intervals
        if (this.intervalId !== undefined) {
            clearInterval(this.intervalId);
        }
        // Remove all cards from the stage and destroy them
        this.stack.forEach(container => {
            container.children.forEach(child => {
                this.app.stage.removeChild(child);
                child.destroy();
            });
            container.destroy({ children: true });
        });
        this.stack = [];
    }
}
exports.default = AceOfShadows;
AceOfShadows.CARD_ASSET_PATH = 'assets/sprites/cardBack.png';
AceOfShadows.TOTAL_CARDS = 144;
AceOfShadows.CARDS_SHIFTER = 3;
